export default __webpack_public_path__ + "static/corridor-eac859b5e4fc5e62984265ef9519a24f.gif";